import { createContext, useContext } from 'react';

export const PwaContext = createContext(null);

export const usePwa = () => {
  const context = useContext(PwaContext);
  if (!context) {
    throw new Error('usePwa can only be used inside PwaProvider');
  }
  return context;
};
